import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.constructor";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

export default {
  data: function data() {
    return {
      // 是否开启校验
      isValid: false,
      // 表单校验结果
      validate: {}
    };
  },
  watch: {},
  methods: {
    isEmpty: function isEmpty(str) {
      if (str == null || str.length === 0) {
        return true;
      }

      return false;
    },

    /**
     * 校验变量
     * @param prop 字段名
     * @param field 字段值
     * @param {Array | Object} rules 规则
     * {
     *   type: 'required | regexp | function',
     *   pattern: '' // 正则表达式，type=regexp时生效
     *   func: Function // 自定义校验方法，type=function时生效，未实现
     *   message: ''
     * }
     */
    validateField: function validateField(prop, field, rules) {
      var vm = this;
      var result = {
        valid: true,
        message: null
      };

      if (this.isValid) {
        if (rules instanceof Array) {
          var _iterator = _createForOfIteratorHelper(rules),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var rule = _step.value;
              result = checkRule(rule);

              if (!result.valid) {
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else {
          result = checkRule(rules);
        }
      }

      if (prop != null) {
        this.$set(this.validate, prop, result);
      }

      function checkRule(rule) {
        var checkResult = null;

        switch (rule.type) {
          case 'required':
            if (field == null || typeof field === 'string' && vm.isEmpty(field) || field instanceof Array && field.length === 0) {
              checkResult = {
                valid: false,
                message: rule.message
              };
            }

            break;

          case 'regexp':
            if (field != null && rule.pattern != null) {
              var reg = new RegExp(rule.pattern);

              if (reg.test(field)) {
                checkResult = {
                  valid: true,
                  message: null
                };
              } else {
                checkResult = {
                  valid: false,
                  message: rule.message
                };
              }
            }

            break;
        }

        if (checkResult == null) {
          return {
            valid: true,
            message: null
          };
        }

        return checkResult;
      }

      return result;
    },

    /**
     * 校验表单
     */
    validateForm: function validateForm() {
      var _this = this;

      this.isValid = true;
      return new Promise(function (resolve, reject) {
        _this.$nextTick(function () {
          var props = Object.keys(_this.validate);

          if (props.length > 0) {
            var result = true;
            var errorMessage = null;

            var _iterator2 = _createForOfIteratorHelper(props),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var prop = _step2.value;
                result = result && _this.validate[prop].valid;

                if (!result) {
                  errorMessage = _this.validate[prop].message;
                  break;
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            result ? resolve() : reject(new Error(errorMessage));
          } else {
            resolve();
          }
        });
      });
    }
  }
};